import { Routes } from '@angular/router';
import { AdminSuppliersService } from '@app/admin/suppliers/services/admin-suppliers.service';

export const suppliersRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () => import('@app/admin/suppliers/components/overview/overview.component').then(component => component.OverviewComponent),
      },
    ],
  },
  {
    path: ':id',
    providers: [AdminSuppliersService],
    children: [
      {
        path: '',
        loadComponent: () => import('@app/admin/suppliers/components/details/details.component').then(component => component.DetailsComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
